import { axios } from "../../util/axiosConfig";
import { account } from "../urls";

const initAccountDelete = () => axios.post(account.initDelete, {});

export default initAccountDelete;
